/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Prevent Scrolling to Top
 * ########################################
 */
jQuery(document).ready(function($) {

    $('.tabs a').click(function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        $(this).tab('show');
    });

});

